module.exports = __webpack_public_path__ + "img/JNT.d18f5b2c.svg";